//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { vms_catalog, asset, area, ossUpload } from "@/api/server";
import assetStatus from "@/mixins/assetStatus";
import formatter from "@/mixins/formatter";
import assetDetail from "@/components/assets/goods/detail";
import assetChange from "@/components/assets/log/changeList";
import { mapState } from "vuex";
import { asset_index } from "@/api/asset";

export default {
	mixins: [assetStatus, formatter],
	data() {
		return {
			is_show_goods: false,
			currentCode: null,
			theloading: false,
			exportLoading: false,
			filters: {
				name: null,
				group: false,
				catalog_id: null,
				area_id: null,
				status: "IDLE",
				locked: null,
				size: 10,
				page: 1,
				location_id: null,
				sort: null,
				barcode: null
			},
			filters1: {
				size: 10,
				page: 1,
				total: 0
			},
			typeList: [],
			list: {
				data: [],
				loading: false,
				total: 0
			},
			areaList: [],
			sortList: [],
			select_ids: []
		};
	},
	computed: {
		...mapState("user", ["innerHeight", "info"])
	},

	components: {
		assetDetail,
		assetChange
	},

	methods: {
		toAddImg(item) {
			let that = this;
			this.$confirm(`确定要替换?`, "提示", {
				type: "warning"
			})
				.then(() => {
					let param = new FormData();
					param.append("file", item.file);
					param.append("duration", 0);
					that.is_loading = true;
					const globalLoading = this.$loading({
						lock: true,
						text: "正在上传",
						spinner: "el-icon-loading",
						background: "rgba(0, 0, 0, 0.6)"
					});
					ossUpload.uploadPhoto(param).then(res => {
						globalLoading.close();
						if (res.data && res.data.length > 0) {
							asset_index
								.edit({
									thumbnail: res.data[0].path,
									ids: this.select_ids
								})
								.then(res1 => {
									if (res1.data) {
										this.$notify({
											title: "提示",
											type: "success",
											duration: 2000,
											message: "上传成功！"
										});
									}
									this.select_ids = false;
									this.$refs.tableIndex.toggleAllSelection(
										false
									);
								});
						}
					});
				})
				.catch(() => { });
		},

		handleSelect(val) {
			this.select_ids = val.map(r => r.id);
		},
		remove(data) {
			this.$confirm("确定要删除吗？", "提示", {
				confirmButtonText: "删除",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				asset.remove({ ids: [data.id] }).then(res => {
					if (res.data) {
						this.$message({ message: "删除成功", type: "success" });
						this.getList();
					}
				});
			});
		},
		getChangeList(data) {
			this.$refs.assetChangeRef.getchangedetail(data);
		},
		getDetail(data) {
			this.currentCode = data.barcode;
			this.is_show_goods = true;
		},
		getPositionRow(row) {
			let area_name = row.area ? row.area.name : "";
			let loca_name = row.location ? row.location.name : "";
			return area_name + "-" + loca_name;
		},
		getStatusRow(row) {
			return this.getAllStatusList(row.status, row.locked);
		},

		handleTheadStyle({ row, column, rowIndex, columnIndex }) {
			let sortName =
				column.property == "add_time_str"
					? "id"
					: column.property == "location.name"
						? "location_id"
						: column.property;

			let ret = this.sortList.findIndex(r => r.name == sortName);

			if (ret != -1) {
				let value1 =
					this.sortList[ret].value == "asc"
						? "ascending"
						: "descending";
				column.order = value1;
			} else {
				column.order = null;
			}
		},

		sortChange(row) {
			let sortValue = row.order == "ascending" ? "asc" : "desc";
			let sortName =
				row.prop == "add_time_str"
					? "id"
					: row.prop == "location.name"
						? "location_id"
						: row.prop == "name"
							? "product_id"
							: row.prop;

			let ret = this.sortList.findIndex(e => e.name == sortName);
			if (ret != -1) {
				this.sortList.splice(ret, 1);
			}

			this.sortList.push({ name: sortName, value: sortValue });
			this.filters.sorts = null;
			let obj = [];
			this.sortList.forEach(r => {
				let obj1 = {};
				obj1[r.name] = r.value;
				obj.push(obj1);
			});
			this.filters.sorts = obj;
			this.togetList(0);
		},

		putAllorder() {
			let param = {
				name: this.filters.name,
				group: this.filters.group,
				catalog_id: this.filters.catalog_id,
				area_id: this.filters.area_id,
				status: this.filters.status,
				locked: this.filters.locked,
				level: this.filters.level
			}
			this.exportLoading = true
			asset.putbarcodeExcel(param).then(res => {
				this.exportLoading = false
				if (res.data) {
					window.open(res.data);
				}
			});
		},
		getAreaList() {
			this.areaList = [];
			area.getAll().then(res => {
				if (res.data) {
					this.areaList = res.data.map(r => {
						return {
							id: r.id,
							name: r.name,
							list: r.list
								? [{ id: null, name: "全部位置" }].concat(
									r.list.map(z => {
										return {
											id: z.id,
											name: z.name
										};
									})
								)
								: []
						};
					});
				}
			});
		},
		handleSizeChange(val) {
			this.filters.size = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.filters.page = val;
			this.getList();
		},

		getTypeList() {
			vms_catalog.getNodeList().then(res => {
				if (res.data) {
					this.typeList = res.data;
				}
			});
		},

		changeByAreaAndLoca(val) {
			if (val && val.length > 0) {
				this.filters.area_id = val[0];
				if (val.length == 2) {
					this.filters.location_id = val[1];
				} else {
					this.filters.location_id = null;
				}
			} else {
				this.filters.area_id = null;
				this.filters.location_id = null;
			}
			this.togetList();
		},

		handleByCatalog(val) {
			if (val && val.length > 0) {
				this.filters.catalog_id = val[val.length - 1];
			} else {
				this.filters.catalog_id = null;
			}
			this.togetList();
		},
		onRowClik(row, column) {
			if (row) {
				this.$refs.tableIndex.toggleRowSelection(row);
			} else {
				this.$refs.tableIndex.clearSelection();
			}
		},
		openDialog(val) {
			this.dialogVisible = true;
		},

		togetList() {
			this.filters.page = 1;
			this.getList();
		},

		getList() {
			this.theloading = true;
			let param = Object.assign(this.filters, {
				lock: this.filters.status == "LOCK" ? true : false
			});
			asset.getList(param).then(res => {
				this.theloading = false;
				if (res.data) {
					this.list.data = res.data.list;
					this.list.total = res.data.totalRow;

					this.list.data.forEach(v => {
						v = Object.assign(v, { num: 1 });
						v.add_time_str = this.timeForLimitTime(v.add_time);
					});
				}
			});
		}
	},

	mounted() {
		this.getAreaList();
		this.getTypeList();
		this.togetList();
	}
};



// WEBPACK FOOTER //
// ./src/views/assets/manage/find.vue